import type { FC } from 'react';
import { Outlet } from '@tanstack/react-router';
import { Menu } from '@client/components/menu/menu.tsx';
import { PageContainer } from '@client/components/layout/page-container.tsx';

// Rendu à l'intérieur de MainLayout (header + footer déjà fournis) : on n'ajoute
// que la sidebar compte + l'Outlet des sous-pages.
// Page avec sidebar → `wide` : pleine largeur, pas de container étagé (qui
// étranglerait la zone contenu).
const AccountLayout: FC = () => {
  return (
    <PageContainer wide className="flex flex-nowrap flex-grow py-7">
      <div className="hidden sticky top-5 w-2/12 side-client-menu-container min-w-fit lg:block">
        <Menu />
      </div>
      <Outlet />
    </PageContainer>
  );
};

export default AccountLayout;
